#import "../fragments/landing-page-stub-fragment.graphql"

mutation CreateLandingPage($input: PageCreateInput!) {
    pageCreate(input: $input) {
        page {
            ...LandingPageStubFragment
        }
    }
}
